import { render, staticRenderFns } from "./Myculturedetails.vue?vue&type=template&id=2e4ac45f"
import script from "./Myculturedetails.vue?vue&type=script&lang=js"
export * from "./Myculturedetails.vue?vue&type=script&lang=js"
import style0 from "./Myculturedetails.vue?vue&type=style&index=0&id=2e4ac45f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports